
export const recordsPerPage = 20;

export const formatNumberWithComma = (numb) => {
    // Convert to number first
    const num = Number(numb);
    
    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};
export const recordsCount = (numb) => {
    // Convert to number first
    const num = Number(numb);

    // Check if valid number
    if (isNaN(num) || !isFinite(num)) {
        return '0';
    }
    // Format the number
    const str = num.toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
};
export const formatCreatedAtDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',    // "Mar"
        day: '2-digit',   // "02"
        year: 'numeric'    // "2025"
    });
};

export const statusData =[
    {id:1,name:"Active"},
    {id:2,name:"Not-Active"},

];

export const getStatusById = (id) => {
    let Id = parseInt(id) ;
    const status = statusData.find(item => item.id === Id);
    return status?.name || "Un-known"
};


export const getCategoriesNameById = (id, Data) => {
    console.log(id)
    let Id = parseInt(id);
    let nameFound = "Name Not found";
    const record = Data.find((item) => item.id === Id);
    if (record) {
        nameFound = record.name;
    } else {
        return "No Record Found";
    }

    return nameFound;
};

export const getUserDetails = (request) => {
    try {
        const userString = sessionStorage.getItem("userInfo");
        if (!userString) {
            throw new Error("No user details found in session storage");
        }
        const user = JSON.parse(userString);
        if (!user) {
            throw new Error("User details are empty");
        }

        const role = user.role || "";
        const Id = user.id || "";
        const branch_id = user.branch_id || "";
        const user_name_id = user.user_name_id || "";
        const user_name = user.name || "";

        switch (request) {
            case "roleId":
                return role;
            case "Id":
                return parseInt(Id);
            case "profile":
                return user;
            case "branchId":
                return branch_id;
            case "userName":
                return user_name;
            case "userNameId":
                return user_name_id;
            default:
                throw new Error("Invalid request parameter");
        }
    } catch (error) {
        console.error("Error in getUserDetails:", error.message);
        return null;
    }
};


// =========== Loans ========================>
export const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

export const calculateDaysRemaining = (dueDate) => {
    if (!dueDate) return 0;
    const due = new Date(dueDate);
    const now = new Date();
    const diffTime = due - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
};

export const calculateProgress = (paid, total) => {
    if (!total || total === 0) return 0;
    return Math.min(100, Math.round((paid / total) * 100));
};